import React from 'react'
import { CiMail } from 'react-icons/ci';
import { PiPhoneThin } from 'react-icons/pi';
import logo from './../../assets/logo.svg';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const TopNav = () => {
    return (
        <div className="bg-main text-white">
            <div className="py-4 xxs:py-8 w-5/6 sm:w-4/6 m-auto  grid grid-cols-3 gap-2 items-center">
                <motion.div
                    initial={{
                        x: -100,
                        opacity: 0
                    }}
                    animate={{
                        x: 0,
                        opacity: 1
                    }}
                    transition={{
                        duration: 0.5
                    }}
                    className="logo md:col-span-1 hidden md:block">
                    <Link to="/">
                        <img src={logo} alt="SecureTech Logo" />
                    </Link>
                </motion.div>
                <div className="col-span-3 md:col-span-2 contact-info text-xs flex flex-col xxs:flex-row gap-2 md:gap-6 justify-evenly md:justify-end">
                    <div className="email flex items-center justify-start gap-2">
                        <div className="text-main bg-white rounded-full p-3">
                            <CiMail />
                        </div>
                        <div className="">
                            <p>Email</p>
                            <span>secureTech@gmail.com</span>
                        </div>
                    </div>
                    <div className="phone flex items-center justify-start gap-2">
                        <div className="text-main bg-white rounded-full p-3">
                            <PiPhoneThin />
                        </div>
                        <div className="">
                            <p>Phone</p>
                            <span>(971) 964 485 5484</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TopNav